import { useState, useEffect } from "react";
import { getUsers } from "../../../../Api/Network";
import { Globals } from "../../../../Global";

export default function useUsers(successCheck, searchValue) {
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchUsers = async () => {
        setLoading(true);
        setError("");

        try {
            const res = await getUsers(Globals.token);

            console.log("res",res)

            if (!res || res.status === 204) {
                setUsers([]);
                setFilteredUsers([]);
                return;
            }

            const data = res.data ?? res;

            if (!Array.isArray(data)) {
                setUsers([]);
                setFilteredUsers([]);
                setError("داده کاربران نامعتبر است");
                return;
            }

            setUsers(data);
            setFilteredUsers(data);

        } catch (err) {
            setError("❌ دریافت لیست کاربران با خطا مواجه شد.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [successCheck]);

    useEffect(() => {
        if (searchValue) {
            const safeUsers = Array.isArray(users) ? users : [];

            setFilteredUsers(
                safeUsers.filter((u) =>
                    String(u.phoneNumber || "")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase())
                )
            );
        } else {
            setFilteredUsers(Array.isArray(users) ? users : []);
        }
    }, [searchValue, users]);

    return {
        users,
        setUsers,
        filteredUsers,
        setFilteredUsers,
        loading,
        error,
        setError,
    };
}



// import { useState, useEffect } from "react";
// import { getUsers } from "../../../../Api/Network";
// import { Globals } from "../../../../Global";

// export default function useUsers(successCheck, searchValue) {
//     const [users, setUsers] = useState([]);
//     const [filteredUsers, setFilteredUsers] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState("");

//     const fetchUsers = async () => {
//         setLoading(true);
//         try {
//             const data = await getUsers(Globals.token);
//             setUsers(data);
//             setFilteredUsers(data);
//         } catch {
//             setError("❌ دریافت لیست کاربران با خطا مواجه شد.");
//         }
//         setLoading(false);
//     };

//     useEffect(() => {
//         fetchUsers();
//     }, [successCheck]);

//     useEffect(() => {
//         if (searchValue) {
//             setFilteredUsers(
//                 users.filter((u) =>
//                     u.phoneNumber.toLowerCase().includes(searchValue.toLowerCase())
//                 )
//             );
//         } else {
//             setFilteredUsers(users);
//         }
//     }, [searchValue, users]);

//     return { users, setUsers, filteredUsers, setFilteredUsers, loading, error, setError };
// }